module.exports = __webpack_public_path__ + "img/pic3.514fec6d.png";